import { Component, OnInit, AfterViewInit } from '@angular/core';

import {rastreamentosModuleName, time} from "../shared/data.service";
import {FrotaApiService} from "../../bens/frotas/shared/frota-api.service";
import {FrotasService} from "../../bens/frotas/shared/frota.service";
import {UtilService} from "../../shared/services/util.service";
import {frotasQuery, frotasQueryComGPS} from "../../bens/frotas/shared/data.service";
import {RastreamentoApiService} from "../shared/rastreamento-api.service";
import {SortService} from "../../shared/services/sort.service";
import {DataService} from "../../core/services/data.service";
import {ProjetoService} from "../../projeto/shared/projeto.service";

declare var google: any;
declare var MarkerClusterer: any;

@Component({
    template: require('./rastreamento-mapa2.component.html'),
    styles: [require('./rastreamento-mapa2.component.css')]
})
export class RastreamentoMapa2Component implements OnInit, AfterViewInit {
    module: any = rastreamentosModuleName;
    tabSelected: string = 'atual';
    frotaSelectId: string = 'frota';
    frotaQuery: any;
    frotaObject: any = {};
    frotaApi: string;
    loadingFrota: boolean = true;
    frotaList: any[] = [];
    timeListStart: any[] = [];
    timeListEnd: any[] = [];
    timeStart: any = {};
    timeEnd: any = {};
    historic: any[] = [];
    loadingHistoric: boolean = false;
    msg: string;
    locationObject: any = {};
    veiculoCategoriaId: number;

    private map: any;
    private timeList: any[] = [];
    private markers: any[] = [];
    private markerCluster: any;
    private polyline: any;
    private coordinates: any[] = [];
    private patternCoordinates: any;
    private showTrail: boolean = false;

    constructor(
        private _rastreamentoApiService: RastreamentoApiService,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _utilService: UtilService,
        private _sortService: SortService,
        private _dataService: DataService,
        private _projetoService: ProjetoService
    ) { }

    ngOnInit() {
        this.timeListStart = this._utilService.cloneObject(time);
        this.timeListEnd = this._utilService.cloneObject(time);
        this.timeList = this._utilService.cloneObject(time);
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);
        this.frotaQuery.where.and.push({gpsImei: {neq: null}});
        this.frotaQuery.where.and.push({gpsModeloId: {neq: null}});
        this.veiculoCategoriaId =  this._frotaService.getTipoVeiculo();
        this.frotaApi = '/categoria/'+ this.veiculoCategoriaId;
        this.initialize();
        this.getAllFrota();
    }

    ngAfterViewInit() {

    }

    getFrotasObject(object: any) {
        this.frotaObject = object;
    }

    clickItem(item: any) {
        const location = this.testObject(item.Rastreamento);
        this.map.setCenter(location.latlng);
        this.map.setZoom(16);
    }

    changeStartTime() {
        if (this.timeStart.Key === 24) {
            return this.timeListEnd = [];
        }

        this.timeListEnd = this.timeList.slice(this.timeStart.Key+1, this.timeList.length);
        this.timeEnd = this.timeListEnd[0];
        this.changeEndTime();

        this.timeStart.label = this._utilService.cloneObject("das " + this.timeStart.Value);
    }

    changeEndTime() {
        this.timeEnd.label = this._utilService.cloneObject("às " +this.timeEnd.Value);
    }

    clickBuscarHistorico() {
        let date: any = document.getElementById('date');
        date = date.value;
        this.msg = '';
        if (this.frotaObject.id && date) {
            let timeStart: any = this.timeStart;
            if (timeStart) {
                timeStart = ((timeStart.Key < 10) ? '0'+timeStart.Key.toString() : timeStart.Key.toString()).concat(":00");
            }

            let timeEnd: any = this.timeEnd;
            if (timeEnd) {
                timeEnd = ((timeEnd.Key < 10) ? '0'+timeEnd.Key.toString() : timeEnd.Key.toString()).concat(":00");
            }

            let start: any = this._utilService.convertStringToDateTime(date, timeStart);
            let end: any = this._utilService.convertStringToDateTime(date, timeEnd);
            let query: any = {
                bemId: this.frotaObject.id,
                inicio: start,
                fim: end
            };

            this.removeMarkers();
            this.getHistoric(query);
        } else {
            this.msg = "Informe o veículo e a data";
            this.historic = [];
            this.removeMarkers();
        }
    }

    setTab(tab:string) {
        this.tabSelected = tab;

        if (tab === 'historico') {
            setTimeout(function() {
                this.historic = [];
                if (this.frotaObject.id) {
                    this._frotaService.setAutocompleteOption(this.frotaSelectId, this.frotaObject);
                }

                this._utilService.disabledFutureDates('date');
                this.timeStart = this.timeListStart[0];
                this.changeStartTime();
            }.bind(this));
        } else {
            this.frotaObject = {};
        }
    }

    isTab(tab: string) {
        var isTab: boolean = (tab === this.tabSelected) ? true: false;
        return isTab;
    }

    frotaTemplateResult = (function(state: any) {
        var template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    private initialize() {
        const project = this._projetoService.getSessionStorage();
        let coord: any = this._dataService.getCoordinates();
        let lat: number =  coord.lat,
            lng: number = coord.lng;
        if (project) {
            lat = project.latitude;
            lng = project.longitude;
        }

        this.patternCoordinates = {lat: lat, lng: lng};
        this.initMap(lat, lng);
    }

    private initMap(lat: any, lng: any) {
        let map: any;
        let latlng: any = new google.maps.LatLng(lat, lng);
        let mapOptions: any = {
            zoom: 12,
            mapTypeControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
        };
        map = new google.maps.Map(document.getElementById("map"), mapOptions);

        let infoContent: any = document.getElementById('info-content');
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);

        let btn: any = document.getElementById('btnRoadmap');
        this.addMapTypeButtonEvent(btn, 'ROADMAP', map);
        btn.click();

        btn = document.getElementById('btnSatellite');
        this.addMapTypeButtonEvent(btn, 'SATELLITE', map);

        btn = document.getElementById('btnHybrid');
        this.addMapTypeButtonEvent(btn, 'HYBRID', map);

        let input: any = document.getElementById('trafficLayer');
        let trafficLayer: any = new google.maps.TrafficLayer();
        this.toogleMapLayerEvent(input, trafficLayer, map);

        input = document.getElementById('transitLayer');
        let transitLayer: any = new google.maps.TransitLayer();
        this.toogleMapLayerEvent(input, transitLayer, map);

        input = document.getElementById('trail');
        input.addEventListener('click', function(e: any) {
            this.showTrail = !this.showTrail;
            if (this.showTrail) {
                input.classList.add("active");
            } else {
                input.classList.remove("active");
                this.removePolyline();
            }
        }.bind(this));
        input.click();

        let div: any = document.getElementById('controls-map');
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(div);

        let btnToggle: any = document.getElementById('btnToggle');
        btnToggle.addEventListener('click', (e: any) => {
            let x: number, lenX: number,
                found: boolean = false,
                controls: any = map.controls[google.maps.ControlPosition.TOP_RIGHT];
            for (x = 0, lenX = controls.b.length; x < lenX; x++) {
                if (controls.b[x].id === 'info-content') {
                    map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(x);
                    found = true;
                    break;
                }
            }

            if (!found) {
                map.controls[google.maps.ControlPosition.TOP_RIGHT].removeAt(0);
                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(infoContent);
                map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);
            }

        });
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(btnToggle);

        map.setCenter(latlng);
        this.map = map;
    }

    private setMarker(frota: any, location: any) {
        if (frota.id) {
            const map: any = this.map;
            const latlng: any = {lat: location.latitude, lng: location.longitude};

            let marker: any =  new google.maps.Marker({
                position: latlng,
                title: frota.identificacao,
                map: map
            });

            var callbackGeoCoder: any = function(response: any) {
                location.address = response;
                const infowindow: any = this.setInfowindow(location, frota);
                infowindow.open(map, marker);
            }.bind(this);

            marker.addListener('click', function () {
                this.geocodeLatLng(latlng, callbackGeoCoder);
            }.bind(this));

            this.markers.push(marker);
            this.coordinates.push(latlng);
        }
    }

    private removeMarkers() {
        let x: number, lenX: number;
        for (x = 0, lenX = this.markers.length; x < lenX; x++) {
            this.markers[x].setMap(null);
        }

        this.markers = [];
        this.coordinates = [];
        this.removeMarkerCluster();
        this.removePolyline();
    }

    private geocodeLatLng(latlng: any, callback: any) {
        let geocoder: any = new google.maps.Geocoder;
        geocoder.geocode({'location': latlng}, function(results, status) {
            if (status === 'OK') {
                if (results[0]) {
                    callback(results[0].formatted_address);
                } else {
                    window.alert('No results found');
                }
            } else {
                window.alert('Geocoder failed due to: ' + status);
            }
        });
    }

    private setInfowindow(location: any, frota: any) {
        let date: any = this._utilService.convertDateToString(location.data);
        let time: any = this._utilService.convertTimeToString(location.data);

        if (!location.address) {
            location.address = ' - ';
        }

        let content: any = '<div>' +
            '<strong>' + frota.identificacao + '</strong>' +
            '<br> ' +
            '<p>Local: ' + location.address + '</p>' +
            '<p>Data/hora: ' + date + ' ' + time + '</p>' +
            '<p>lat: ' + location.latitude + ' / lng:' + location.longitude + '</p>' +
            '<p>Velocidade: ' + location.kmPorHora + ' km/h</p>' +
            '</div>';

        let infowindow: any = new google.maps.InfoWindow({
            content: content
        });

        return infowindow;
    }

    private setPolyline() {
        const coordinates: any = this.coordinates;

        //draw line
        let flightPath: any = new google.maps.Polyline({
            path: coordinates,
            geodesic: true,
            strokeColor: '#8075D6',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });

        flightPath.setMap(this.map);
        this.polyline = flightPath;
    }

    private removePolyline() {
        if (this.polyline) {
            this.polyline.setMap(null);
        }
    }

    private setMarkerCluster() {
        // Add a marker clusterer to manage the markers.
        let markerCluster: any = new MarkerClusterer(this.map, this.markers,
            {imagePath: 'assets/markerclusterer-1.0/m/m'});

        this.markerCluster = markerCluster;
    }

    private removeMarkerCluster() {
        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
        }
    }

    private getAllFrota() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.removeMarkers();
                Response.forEach((item: any) => {
                    if (item.Imagens.length) {
                        item.imageUrl = item.Imagens[0].url;
                    }

                    if (item.Rastreamento) {
                        if (item.Rastreamento.latitude && item.Rastreamento.longitude) {
                            this.setMarker(item, item.Rastreamento);
                        }
                    } else {
                        item.Rastreamento = {};
                    }
                });

                this.frotaList = Response;
                this.map.setCenter(this.patternCoordinates);
                this.map.setZoom(12);
            }
            this.loadingFrota = false;
        }.bind(this));

        let query: any = this._utilService.cloneObject(frotasQueryComGPS);
        query.where.ativo = true;
        this._frotaApiService.onGetAllRastreamento(this.veiculoCategoriaId, query, onDone);
    }

    private getCurrentLocation() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.locationObject = Response;
                Response = this.testObject(Response);
                if (Response.latlng) {
                    const found: boolean = this.checkCoordinates(Response);

                    if (!found) {
                        //set o marker no mapa somente se as coordenadas não existirem no array
                        let rastro: any = this._utilService.cloneObject(this.coordinates);
                        this.removeMarkers();
                        this.setMarker(Response);

                        rastro.reverse();
                        rastro.unshift(this.coordinates[0]);
                        rastro = (rastro.length > 5) ? rastro.slice(0, 5) : rastro;
                        this.coordinates = rastro.reverse();
                        if(this.showTrail) {
                            this.setPolyline();
                        }

                        this.map.setCenter(Response.latlng);
                        this.map.setZoom(16);
                    }
                }
            } else {
                //this._utilService.swalMessageWarningCustom("Não foi possível obter a localidade do veículo");
             }
            setTimeout(function() {
                if (this.tabSelected === 'atual'){
                    this.getCurrentLocation();
                }
            }.bind(this), 10000);
        }.bind(this));

        if (this.frotaObject.id) {
            this._rastreamentoApiService.onGetCurrent(this.frotaObject.id, onDone);
        }
    }

    private getHistoric(query: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                Response = this._sortService.sortArray(Response, ['data']);

                let found: boolean,
                    latlng: any = this.patternCoordinates;
                Response.forEach((item: any) => {
                    item = this.testObject(item);
                    if (item.latlng) {
                        latlng = item.latlng;
                        found = this.checkCoordinates(item);
                        if (!found) {
                            this.setMarker(item);
                        }
                    }
                });

                this.historic = Response;

                if (Response.length) {
                    this.setMarkerCluster();
                    this.setPolyline();

                    this.map.setCenter(latlng);
                    this.map.setZoom(16);
                } else {
                    this.msg = "Nenhum dado encontrado";
                }
            } else {
                this._utilService.swalMessageWarningCustom("Não foi possível obter a localidade do veículo");
            }
            this.loadingHistoric = false;
        }.bind(this));

        this.loadingHistoric = true;
        this._rastreamentoApiService.onGetPeriod(query, onDone);
    }

    private checkCoordinates(newLocation: any) {
        let x: number, lenX: number,
            found: boolean = false;

        for (x = 0, lenX = this.coordinates.length; x < lenX; x++) {
            if (this.coordinates[x].lat === newLocation.latitude && this.coordinates[x].lng === newLocation.longitude) {
                found = true;
            }
        }

       return found;
    }

    private testObject(location: any) {
        if (location.longitude && location.latitude) {
            location.latlng = {lat: location.latitude, lng: location.longitude};
        }

        return location;
    }

    private addMapTypeButtonEvent(btn: any, type: string, map: any) {
        btn.addEventListener('click', function(e: any) {
            let c: any = document.getElementsByClassName('btns-controls');
            let x: number, lenX:  number;
            for (x = 0, lenX = c.length; x < lenX; x++) {
                c[x].classList.remove("active");
            }
            e.target.classList.add("active");
            map.setMapTypeId(google.maps.MapTypeId[type])
        });
    }

    private toogleMapLayerEvent(input: any, layer: any, map: any) {
        input.addEventListener('click', function(e: any) {
            if (!layer.getMap()) {
                input.classList.add("active");
                layer.setMap(map);
            } else {
                input.classList.remove("active");
                layer.setMap(null);
            }
        });
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/rastreamento-mapa2/rastreamento-mapa2.component.ts
 **/